import { render, staticRenderFns } from "./ThumbWrapper.vue?vue&type=template&id=70e4646c&scoped=true"
import script from "./ThumbWrapper.vue?vue&type=script&lang=ts"
export * from "./ThumbWrapper.vue?vue&type=script&lang=ts"
import style0 from "./ThumbWrapper.vue?vue&type=style&index=0&id=70e4646c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e4646c",
  null
  
)

export default component.exports